import { render } from "./BoardContent.vue?vue&type=template&id=1957f915&scoped=true"
import script from "./BoardContent.vue?vue&type=script&lang=js"
export * from "./BoardContent.vue?vue&type=script&lang=js"

import "./BoardContent.vue?vue&type=style&index=0&id=1957f915&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1957f915"]])

export default __exports__